import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var Plus = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg",
    "stroke": "currentColor",
    "strokeLinecap": "round",
    "strokeLinejoin": "round"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    x2: 12,
    y1: 5,
    y2: 19
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5,
    x2: 19,
    y1: 12,
    y2: 12
  }));
});
Plus.displayName = 'Plus';
export var PlusDimensions = {
  height: 24,
  width: 24
};